// src/components/ConfirmDialog.jsx
import React from "react";
import Button1 from "@material-ui/core/Button";

export function ConfirmDialog({ open, title, message, onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div style={{
      position:       "fixed",
      inset:          0,
      zIndex:         1400,
      background:     "#0006",
      display:        "flex",
      alignItems:     "center",
      justifyContent: "center",
    }}>
      <div style={{
        background:    "#fff",
        borderRadius:  12,
        width:         "min(420px, 92vw)",
        boxShadow:     "0 8px 40px #0003",
      }}>
        {/* Header */}
        <div style={{
          padding:       "16px 24px",
          borderBottom:  "1px solid #e2e8f0",
          display:       "flex",
          alignItems:    "center",
          justifyContent: "space-between",
        }}>
          <span style={{ fontWeight: 800, fontSize: 15, color: "#1e293b" }}>{title}</span>
          <button onClick={onCancel} style={{
            background: "none", border: "none", fontSize: 20,
            cursor: "pointer", color: "#64748b", lineHeight: 1,
          }}>✕</button>
        </div>

        {/* Body */}
        <div style={{ padding: "20px 24px" }}>
          <p style={{ fontSize: 14, color: "#475569", lineHeight: 1.6 }}>{message}</p>
        </div>

        {/* Footer */}
        <div style={{
          padding:       "12px 24px",
          borderTop:     "1px solid #e2e8f0",
          display:       "flex",
          justifyContent: "flex-end",
          gap:           10,
        }}>
          <Button1
            variant="outlined"
            size="small"
            onClick={onCancel}
            style={{ textTransform: "none", fontSize: 13 }}
          >
            ยกเลิก
          </Button1>
          <Button1
            variant="contained"
            size="small"
            onClick={onConfirm}
            style={{
              textTransform: "none",
              fontSize:      13,
              fontWeight:    700,
              background:    "#dc2626",
              color:         "#fff",
            }}
          >
            🗑️ ยืนยันลบ
          </Button1>
        </div>
      </div>
    </div>
  );
}
